import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/Login';
import Layout from '@/components/Layout';
import Dashboard from '@/housekeeping/Dashboard';
import DashboardSales from '@/housekeeping/DashboardSales';
import Housemaids from '@/housekeeping/Housemaids';
import Laundry from '@/clerkinn/Laundry';
import Minibar from '@/clerkinn/Minibar';
import PlanningHousekeeping from '@/housekeeping/Planning';
import ProblemReport from '@/housekeeping/ProblemReport';
import Maintenance from '@/housekeeping/Maintenance';
import Products from '@/clerkinn/Products';
import Rooms from '@/housekeeping/Rooms';
import OtherEnviroments from '@/housekeeping/OtherEnviroments';
import Settings from '@/housekeeping/Settings';
import States from '@/housekeeping/States';
import Transfers from '@/clerkinn/Transfers';
import Users from '@/housekeeping/Users';
import NotFound from '@/components/NotFound';
import Guest from '@/clerkinn/Guest';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			children: [
				{
					components: {
						default: Dashboard,
					},
					name: 'dashboard',
					path: '/dashboard-housekeeping',
					meta: {
						breadcrumb: 'Dashboard',
					},
					redirect: '/dashboard/main',
					children: [
						{
							component: () => import('@/housekeeping/dashboard/Dashboard'),
							name: 'main-dashboard',
							path: 'main',
						},
						{
							component: () => import('@/housekeeping/dashboard/DetailByState'),
							name: 'detail-by-state',
							path: 'state/:stateId/:stateName',
							meta: {
								breadcrumb: 'State',
							},
							props: true,
						},
						{
							component: () => import('@/housekeeping/dashboard/HousemaidsByState'),
							name: 'housemaids-by-state',
							path: 'housemaids-by-state/:stateId/:stateName',
							meta: {
								breadcrumb: 'Housemaids by state',
							},
							props: true,
						},
						{
							component: Maintenance,
							name: 'maintenance-container',
							path: '/maintenance',
							meta: {
								breadcrumb: 'Maintenance',
							},
							redirect: '/maintenance/unresolved',
							children: [
								{
									component: () => import('@/housekeeping/maintenance/Unresolved'),
									name: 'unresolved-maintenance',
									path: 'unresolved',
								},
								{
									component: () => import('@/housekeeping/maintenance/Solved'),
									name: 'solved-maintenance',
									path: 'solved',
								},
							],
						},
					],
				},
				{
					component: DashboardSales,
					name: 'dashboard-sales',
					path: '/dashboard/sales',
					meta: {
						breadcrumb: 'Sales',
					},
				},
				{
					components: {
						default: Housemaids,
					},
					name: 'housemaids',
					path: '/housemaids',
					meta: {
						breadcrumb: 'Housemaids',
					},
					redirect: '/housemaids/list',
					children: [
						{
							component: () => import('@/housekeeping/housemaids/Profile'),
							meta: {
								breadcrumb: 'Perfil Mucama',
							},
							name: 'housemaids-profile',
							path: ':id/profile',
							props: true,
						},
						{
							component: () => import('@/housekeeping/housemaids/List'),
							name: 'housemaids-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
						{
							component: () => import('@/housekeeping/housemaids/Create'),
							name: 'housemaids-new',
							path: 'new',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/housekeeping/housemaids/Create'),
							name: 'housemaids-config',
							path: ':housemaidId/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
						{
							component: () => import('@/housekeeping/housemaids/Assign'),
							name: 'housemaids-assign',
							path: 'asignar',
							meta: {
								breadcrumb: 'Asignar',
							},
						},
					],
				},
				{
					components: {
						default: Rooms,
					},
					name: 'rooms',
					path: '/rooms',
					meta: {
						breadcrumb: 'Habitaciones',
						tab: 'Rooms',
					},
					redirect: '/rooms/list',
					children: [
						{
							component: () => import('@/housekeeping/rooms/List'),
							name: 'room-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
						{
							component: () => import('@/housekeeping/rooms/RoomDetail'),
							name: 'room-detail',
							path: ':roomId',
							meta: {
								breadcrumb: 'Room',
							},
							props: true,
						},
						{
							component: () => import('@/housekeeping/rooms/RoomPhotos'),
							name: 'room-photos',
							meta: {
								breadcrumb: 'Fotos',
							},
							path: ':roomId-:roomNumber/photos/:maidId/maid',
							props: true,
						},
						{
							component: () => import('@/housekeeping/rooms/FormRoom'),
							name: 'create-room',
							path: 'new/create',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/housekeeping/rooms/FormRoom'),
							name: 'edit-room',
							path: ':id/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
					],
				},
				{
					component: OtherEnviroments,
					name: 'other-enviroments',
					path: '/other-enviroments',
					meta: {
						breadcrumb: 'Other enviroments',
						tab: 'Other enviroments',
					},
				},
				{
					components: {
						default: Products,
					},
					name: 'products',
					path: '/products',
					meta: {
						breadcrumb: 'Products',
					},
					redirect: '/products/list',
					children: [
						{
							component: () => import('@/clerkinn/products/List'),
							name: 'product-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
						{
							component: () => import('@/clerkinn/products/Create'),
							name: 'create-product',
							path: 'new',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/clerkinn/products/Create'),
							name: 'config-product',
							path: ':productId/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
					],
				},
				{
					components: {
						default: Laundry,
					},
					name: 'laundry',
					path: '/laundry',
					meta: {
						breadcrumb: 'Laundry',
					},
					redirect: '/laundry/list',
					children: [
						{
							component: () => import('@/clerkinn/laundry/List'),
							name: 'laundry-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
						{
							component: () => import('@/clerkinn/laundry/Create'),
							name: 'form-laundry',
							path: 'new',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/clerkinn/laundry/Create'),
							name: 'config-laundry',
							path: ':laundryId/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
					],
				},
				{
					component: () => import('@/clerkinn/Billing'),
					name: 'billing',
					path: '/billing',
					meta: {
						breadcrumb: 'Billing',
					},
					redirect: 'billing/list',
					children: [
						{
							component: () => import('@/clerkinn/billing/List'),
							name: 'list',
							path: 'list',
						},
					],
				},
				{
					component: () => import('@/housekeeping/LostFoundContainer'),
					name: 'lostandfound',
					path: '/lost-&-found',
					meta: {
						breadcrumb: 'Lost & Found',
					},
					redirect: '/lost-&-found/lost',
					children: [
						{
							component: () => import('@/housekeeping/Lost&Found'),
							name: 'lost',
							path: 'lost',
						},
						{
							component: () => import('@/housekeeping/Found'),
							name: 'found',
							path: 'found',
						},
					],
				},
				{
					component: ProblemReport,
					name: 'problem-report',
					path: '/problem-report',
					meta: {
						breadcrumb: 'Problem report',
					},
					redirect: '/problem-report/unresolved',
					children: [
						{
							component: () => import('@/housekeeping/Unresolved'),
							name: 'unresolved',
							path: 'unresolved',
						},
						{
							component: () => import('@/housekeeping/Solved'),
							name: 'solved',
							path: 'solved',
						},
					],
				},
				{
					components: {
						default: Users,
					},
					name: 'users',
					path: '/users',
					meta: {
						breadcrumb: 'Users',
					},
					redirect: '/users/list',
					children: [
						{
							component: () => import('@/housekeeping/users/List'),
							name: 'users-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
						{
							component: () => import('@/housekeeping/users/Create'),
							name: 'users-new',
							path: 'new',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/housekeeping/users/Create'),
							name: 'users-config',
							path: ':userId/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
					],
				},
				{
					component: PlanningHousekeeping,
					name: 'planning-housekeeping',
					path: '/planning-housekeeping',
					meta: {
						breadcrumb: 'Planning',
					},
				},
				{
					components: {
						default: Settings,
					},
					name: 'settings',
					path: '/type-cleaning',
					meta: {
						breadcrumb: 'Type cleaning',
					},
					redirect: '/type-cleaning/list',
					children: [
						{
							component: () => import('@/housekeeping/settings/List'),
							name: 'settings-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
						{
							component: () => import('@/housekeeping/settings/Create'),
							name: 'settings-new',
							path: 'new',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/housekeeping/settings/Create'),
							name: 'settings-config',
							path: ':settingId/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
					],
				},
				{
					components: {
						default: States,
					},
					name: 'states',
					path: '/states',
					meta: {
						breadcrumb: 'States',
					},
					redirect: '/states/list',
					children: [
						{
							component: () => import('@/housekeeping/states/List'),
							name: 'states-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
						{
							component: () => import('@/housekeeping/states/Create'),
							name: 'states-new',
							path: 'new',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/housekeeping/states/Create'),
							name: 'states-config',
							path: ':stateId/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
					],
				},
				{
					component: () => import('@/components/Docs'),
					name: 'docs',
					path: '/docs',
					meta: {
						breadcrumb: 'Documentation',
					},
				},
				{
					components: {
						default: Minibar,
					},
					name: 'minibar',
					path: '/minibar',
					meta: {
						breadcrumb: 'Minibar',
					},
					redirect: '/minibar/list',
					children: [
						{
							component: () => import('@/clerkinn/minibar/List'),
							name: 'minibar-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
						{
							component: () => import('@/clerkinn/minibar/Create'),
							name: 'minibar-new',
							path: 'new',
							meta: {
								breadcrumb: 'New',
							},
						},
						{
							component: () => import('@/clerkinn/minibar/Create'),
							name: 'minibar-config',
							path: ':minibarId/edit',
							meta: {
								breadcrumb: 'Edit',
							},
							props: true,
						},
						{
							component: () => import('@/clerkinn/minibar/Products'),
							name: 'minibar-products',
							path: ':id/:name/products',
							meta: {
								breadcrumb: 'Products',
							},
							props: true,
						},
					],
				},
				{
					components: {
						default: Minibar,
					},
					name: 'warehouses',
					path: '/warehouses',
					meta: {
						breadcrumb: 'Warehouse',
					},
					redirect: '/warehouses/list',
					children: [
						{
							component: () => import('@/clerkinn/minibar/List'),
							name: 'warehouses-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
						{
							component: () => import('@/clerkinn/minibar/Create'),
							name: 'warehouses-new',
							path: 'new',
							meta: {
								breadcrumb: 'Nuevo',
							},
						},
						{
							component: () => import('@/clerkinn/minibar/Create'),
							name: 'warehouses-config',
							path: ':minibarId/edit',
							meta: {
								breadcrumb: 'Editar',
							},
							props: true,
						},
						{
							component: () => import('@/clerkinn/minibar/Products'),
							name: 'warehouses-products',
							path: ':id/:name/products',
							meta: {
								breadcrumb: 'Productos',
							},
							props: true,
						},
					],
				},
				{
					components: {
						default: Guest,
					},
					name: 'guest',
					path: '/guest',
					meta: {
						breadcrumb: 'Huésped',
					},
					redirect: '/guest/list-guest',
					children: [
						{
							component: () => import('@/clerkinn/guest/new-guest'),
							name: 'new-guest',
							path: 'new-guest',
							menta: {
								breadcrumb: 'Nuevo Huésped',
							},
							props: true,
						},
						{
							name: 'edit-guest',
							path: ':id/edit-guest',
							meta: {
								breadcrumb: 'Editar Huesped',
							},
							props: true,
							component: () => import('@/clerkinn/guest/new-guest'),
						},
						{
							component: () => import('@/clerkinn/guest/list-guest'),
							name: 'list-guest',
							path: 'list-guest',
							meta: {
								breadcrumb: 'Lista de Huéspedes',
							},
						},
						{
							component: () => import('@/clerkinn/guest/history-guest'),
							name: 'history-guest',
							path: 'history-guest',
							meta: {
								breadcrumb: 'Historial del Huesped',
							},
						},
						{
							component: () => import('@/clerkinn/guest/detail-guest'),
							name: 'detail-guest',
							path: 'detail-guest',
							meta: {
								breadcrumb: 'Detalle de Huesped',
							},
						},
					],
				},
				{
					components: {
						default: Transfers,
					},
					name: 'transfers',
					path: '/transfers',
					meta: {
						breadcrumb: 'Transfers',
					},
					redirect: '/transfers/list',
					children: [
						{
							component: () => import('@/clerkinn/transfers/List'),
							name: 'transfer-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
					],
				},
				{
					component: () => import('@/clerkinn/Reports'),
					name: 'reports',
					path: '/reports',
					meta: {
						breadcrumb: 'Reportes',
					},
					redirect: '/reports/list',
					children: [
						{
							component: () => import('@/clerkinn/reports/Restaurant'),
							meta: {
								breadcrumb: 'Restaurante',
							},
							name: 'restaurant',
							path: 'restaurant',
						},
						{
							component: () => import('@/clerkinn/reports/Kitchen'),
							meta: {
								breadcrumb: 'Cocina',
							},
							name: 'kitchen',
							path: 'kitchen',
						},
						{
							component: () => import('@/clerkinn/reports/Occupancy-new'),
							meta: {
								breadcrumb: 'Ocupación Nueva',
							},
							name: 'occupancy-new',
							path: 'occupancy-new',
						},
						{
							component: () => import('@/clerkinn/reports/List'),
							name: 'reports-list',
							path: 'list',
						},
						{
							component: () => import('@/clerkinn/reports/Occupancy'),
							meta: {
								breadcrumb: 'Ocupación',
							},
							name: 'report-occupancy',
							path: 'occupancy',
						},
						{
							component: () => import('@/clerkinn/reports/Company'),
							meta: {
								breadcrumb: 'Empresa',
							},
							name: 'report-company',
							path: 'company',
						},
						{
							component: () => import('@/clerkinn/reports/Bookings'),
							meta: {
								breadcrumb: 'Reservas',
							},
							name: 'report-bookings',
							path: 'bookings',
						},
					],
				},
				{
					component: () => import('@/clerkinn/Kardex'),
					name: 'kardex',
					path: 'products/:productId/:productName/:warehouseId?/kardex',
					meta: {
						breadcrumb: 'Kardex',
					},
					props: true,
				},
				{
					components: {
						default: () => import('@/configuration/Configuration'),
					},
					name: 'configuration',
					path: '/configuration',
					meta: {
						breadcrumb: 'Configuration',
					},
					redirect: '/configuration/company',
					children: [
						{
							component: () => import('@/configuration/Company'),
							name: 'company',
							path: 'company',
							meta: {
								breadcrumb: 'Company',
							},
						},
						{
							component: () => import('@/configuration/Subsidiaries'),
							name: 'subsidiaries',
							path: 'subsidiaries',
							meta: {
								breadcrumb: 'Subsidiaries',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Customers'),
					},
					name: 'customers',
					path: '/customers',
					redirect: '/customers/list',
					children: [
						{
							component: () => import('@/clerkinn/customers/List'),
							name: 'customers-list',
							path: 'list',
							meta: {
								breadcrumb: 'Clientes',
							},
						},
						{
							component: () => import('@/clerkinn/customers/New-Customer'),
							name: 'config-customer',
							path: 'edit',
							meta: {
								breadcrumb: 'Edit',
							},
						},
						{
							component: () => import('@/clerkinn/customers/New-Customer'),
							name: 'new-customer',
							path: 'new',
							meta: {
								breadcrumb: 'Nuevo Cliente',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Calendar'),
					},
					name: 'calendar',
					path: '/calendar',
					meta: {
						breadcrumb: 'Calendar',
					},
					redirect: '/calendar/:bookingCode?',
					children: [
						{
							component: () => import('@/clerkinn/calendar/CmsCalendar'),
							name: 'cms-calendar',
							path: ':bookingCode?',
							props: true,
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Housekeeping'),
					},
					name: 'housekeeping',
					path: '/housekeeping',
					meta: {
						breadcrumb: 'Housekeeping',
					},
					redirect: '/housekeeping/list',
					children: [
						{
							component: () => import('@/clerkinn/housekeeping/List'),
							name: 'housekeeping-list',
							path: 'list',
							meta: {
								breadcrumb: 'List',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Alarm'),
					},
					name: 'alarm',
					path: '/alarm',
					meta: {
						breadcrumb: 'Alarm',
					},
					redirect: '/alarm/list',
					children: [
						{
							component: () => import('@/clerkinn/alarm/List'),
							name: 'alarm-list',
							path: 'list',
							meta: {
								breadcrumb: 'Crear alarma',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/CheckIn'),
					},
					name: 'check-in',
					path: 'check-in',
					meta: {
						breadcrumb: 'Check In',
					},
					redirect: '/check-in/new-form',
					children: [
						{
							component: () => import('@/clerkinn/checkin/Form'),
							name: 'check-in-form',
							path: 'form/:bookingCode?/:hotelId?',
							props: true,
						},
						{
							component: () => import('@/clerkinn/checkin/NewForm'),
							name: 'checkin-form-tabs',
							path: 'new-form/:hotelId/:roomTypeId/:customerId?',
							props: true,
						},
					],
				},
				{
					component: () => import('@/clerkinn/multi-rooms/MultiRooms'),
					name: 'multi-rooms-reservation',
					path: 'multi-rooms-reservation',
					meta: {
						breadcrumb: 'Reservas',
					},
					redirect: '/multi-rooms-reservation/select-rooms',
					children: [
						{
							component: () => import('@/clerkinn/multi-rooms/SelectRooms'),
							name: 'select-rooms',
							path: 'select-rooms',
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Bookings'),
					},
					name: 'bookings',
					path: 'bookings',
					meta: {
						breadcrumb: 'Reservas',
					},
					redirect: '/bookings/list',
					children: [
						{
							component: () => import('@/clerkinn/bookings/List'),
							name: 'booking-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
						{
							component: () => import('@/clerkinn/bookings/New'),
							name: 'booking-new',
							path: 'new/:id/:amountPayment',
							meta: {
								breadcrumb: 'Nueva',
							},
						},
						{
							component: () => import('@/clerkinn/bookings/New'),
							name: 'booking-edit',
							path: ':codeBooking/edit',
							meta: {
								breadcrumb: 'Editar',
							},
							props: true,
						},
						{
							component: () => import('@/clerkinn/bookings/Detail'),
							name: 'booking-detail',
							path: ':bookingCode/detail',
							meta: {
								breadcrumb: 'Detalle',
							},
							props: true,
						},
						{
							component: () => import('@/clerkinn/bookings/Filter'),
							name: 'booking-filter',
							path: 'query',
							meta: {
								breadcrumb: 'Consulta',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Channels'),
					},
					name: 'channels',
					path: 'otas',
					meta: {
						breadcrumb: 'OTAS',
					},
					redirect: '/otas/list',
					children: [
						{
							component: () => import('@/clerkinn/channels/List'),
							name: 'channels-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
						{
							component: () => import('@/clerkinn/channels/New'),
							name: 'channels-new',
							path: 'new',
							meta: {
								breadcrumb: 'Nuevo',
							},
						},
						{
							component: () => import('@/clerkinn/channels/New'),
							name: 'channels-config',
							path: ':channelId/config',
							meta: {
								breadcrumb: 'Editar',
							},
							props: true,
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Units'),
					},
					name: 'units',
					path: '/units',
					meta: {
						breadcrumb: 'Unidades',
					},
					redirect: '/units/list',
					children: [
						{
							component: () => import('@/clerkinn/units/List'),
							name: 'units-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Categories'),
					},
					name: 'categories',
					path: '/categories',
					meta: {
						breadcrumb: 'Categorías',
					},
					redirect: '/categories/list',
					children: [
						{
							component: () => import('@/clerkinn/categories/List'),
							name: 'categories-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Rooms'),
					},
					name: 'clerkinn-rooms',
					path: '/new-rooms',
					meta: {
						breadcrumb: 'Habitaciones',
					},
					redirect: '/new-rooms/list',
					children: [
						{
							component: () => import('@/clerkinn/rooms/List'),
							name: 'rooms-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Buildings'),
					},
					name: 'buildings',
					path: '/buildings',
					meta: {
						breadcrumb: 'Edificios',
					},
					redirect: '/buildings/list',
					children: [
						{
							component: () => import('@/clerkinn/buildings/List'),
							name: 'buildings-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Sales'),
					},
					name: 'sales',
					path: '/sales',
					meta: {
						breadcrumb: 'Ventas',
					},
					redirect: '/sales/list',
					children: [
						{
							component: () => import('@/clerkinn/sales/List'),
							name: 'sales-list',
							path: 'list',
							meta: {
								breadcrumb: 'Lista',
							},
						},
						{
							component: () => import('@/clerkinn/sales/Detail'),
							name: 'sale-detail',
							path: ':id/detail',
							meta: {
								breadcrumb: 'Detalle',
							},
							props: true,
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Planning'),
					},
					name: 'planning',
					path: '/planning',
					meta: {
						breadcrumb: 'Planning',
					},
					redirect: '/planning/list',
					children: [
						{
							component: () => import('@/clerkinn/planning/List'),
							name: 'planning-list',
							path: 'list',
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Dashboard'),
					},
					name: 'dashboard-clerkinn',
					path: '/dashboard',
					meta: {
						breadcrumb: 'Dashboard',
					},
					redirect: '/dashboard',
					children: [
						{
							component: () => import('@/clerkinn/dashboard/Dashboard'),
							name: 'dashboard-clerkinn-main',
							path: '',
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/Pos'),
					},
					name: 'pos-clerkinn',
					path: '/pos',
					meta: {
						breadcrumb: 'POS',
					},
					redirect: '/pos',
					children: [
						{
							component: () => import('@/clerkinn/pos/Pos'),
							name: 'pos',
							path: '',
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/calendar/Prepayment'),
					},
					meta: {
						breadcrumb: 'Adelanto',
					},
					name: 'prepayment',
					path: '/booking/:bookingCode/prepayment',
					redirect: '/booking/:bookingCode/prepayment',
					children: [
						{
							component: () => import('@/clerkinn/calendar/ListPrepayment'),
							name: 'list-prepayment',
							path: '/booking/:bookingCode/prepayment',
							props: true,
						},
						{
							component: () => import('@/clerkinn/calendar/FormPrepayment'),
							name: 'form-prepayment',
							path: ':idDocument/form',
							props: true,
						},
					],
				},
				{
					components: {
						default: () => import('@/clerkinn/companies/companies'),
					},
					meta: {
						breadcrumb: 'Empresas',
					},
					name: 'companies',
					path: '/company',
					redirect: '/company/list',
					children: [
						{
							component: () => import('@/clerkinn/companies/companies-list'),
							name: 'companies-list',
							path: 'list',
						},
						{
							component: () => import('@/clerkinn/companies/companies-new'),
							name: 'companies-new',
							path: 'new',
							meta: {
								breadcrumb: 'Nueva',
							},
						},
						{
							component: () => import('@/clerkinn/companies/companies-new'),
							name: 'companies-edit',
							path: ':id/edit',
							meta: {
								breadcrumb: 'Editar',
							},
							props: true,
						},
						{
							component: () => import('@/clerkinn/companies/companies-statistics'),
							name: 'companies-statistics',
							path: ':id/statistics',
							meta: {
								breadcrumb: 'Estadísticas',
							},
							props: true,
						},
						{
							component: () => import('@/clerkinn/companies/companies-history'),
							name: 'companies-history',
							path: ':id/history',
							meta: {
								breadcrumb: 'Historial',
							},
							props: true,
						},
					],
				},
				{
					component: () => import('@/clerkinn/blocking/blocking'),
					name: 'blocking',
					path: 'blocking',
					meta: {
						breadcrumb: 'Bloquear Canales',
					},
				},
				{
					component: () => import('@/clerkinn/sellers/Seller'),
					name: 'sellers',
					path: 'sellers',
					redirect: '/sellers/list',
					meta: {
						breadcrumb: 'Vendedores',
					},
					children: [
						{
							name: 'sellers-list',
							path: 'list',
							component: () => import('@/clerkinn/sellers/List'),
						},
						{
							name: 'sellers-new',
							path: 'new',
							meta: {
								breadcrumb: 'Crear vendedor',
							},
							component: () => import('@/clerkinn/sellers/New'),
						},
						{
							name: 'sellers-edit',
							path: 'edit/:sellerId',
							meta: {
								breadcrumb: 'Editar vendedor',
							},
							component: () => import('@/clerkinn/sellers/New'),
						},
					],
				},
				{
					component: () => import('@/clerkinn/users/Users'),
					meta: {
						breadcrumb: 'Usuarios',
					},
					name: 'user',
					path: 'user',
					redirect: '/user/list',
					children: [
						{
							component: () => import('@/clerkinn/users/List'),
							name: 'user-list',
							path: 'list',
						},
						{
							component: () => import('@/clerkinn/users/Activities'),
							name: 'user-activities',
							path: 'activity',
						},
						{
							component: () => import('@/clerkinn/users/New'),
							name: 'config-user',
							path: 'edit',
							meta: {
								breadcrumb: 'Editar Usuario',
							},
						},
						{
							component: () => import('@/clerkinn/users/New'),
							name: 'new-user',
							path: 'new',
							meta: {
								breadcrumb: 'Nuevo Usuario',
							},
						},
					],
				},
				{
					component: () => import('@/clerkinn/shared/EmploymentComponent'),
					name: 'employment-component',
					path: 'employment-component',
				},
			],
			components: {
				default: Layout,
			},
			name: 'home',
			path: '/',
			redirect: '/dashboard',
		},
		{
			components: {
				login: Login,
			},
			name: 'login',
			path: '/login',
		},
		{
			component: NotFound,
			name: 'notfound',
			path: '*',
		},
	],
});

router.beforeEach((to, from, next) => {
	if (to.name !== 'login') {
		const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
		if (token) {
			return next();
		}
		return next({ name: 'login' });
	}
	return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js